import Vue from 'vue'

Vue.component('icon-arrow-left', require('./arrow-left').default)
Vue.component('icon-arrow-right', require('./arrow-right').default)
Vue.component('icon-warning', require('./warning').default)
Vue.component('icon-plus', require('./plus').default)
Vue.component('icon-vk', require('./vk').default)
Vue.component('icon-tw', require('./tw').default)
Vue.component('icon-fb', require('./fb').default)
Vue.component('icon-ok', require('./ok').default)
// Vue.component('icon-inst', require('./inst').default)
